<div id="feedbacktab"><a href="#" (click)="handleOpenFeedbackForm()">Feedback</a></div>

<div id="warning-message">
    <h2>Evaluatie<br>ondersteuning</h2>
    <p>
        De Evaluatieondersteuning helpt bij het vaststellen van het behandeldoel en het maken van afspraken over evalueren. De cliënt en behandelaar vullen samen een aantal vragen in. Na het beantwoorden volgt een overzicht met het evaluatieplan en tips voor het evaluatiegesprek. Dit overzicht kun je downloaden en gemakkelijk aanpassen tijdens de behandeling. 
        <br><br>
        <i>Gebruik de online Evaluatieondersteuning op je desktop of laptop. Kopieer onderstaande link en mail deze naar je eigen mailadres.</i>
    </p>
    <button (click)="copyToClipboard()" class="next-question-button next-question-button-share">
        Kopieer link
    </button>
    <br>
    <div #feedback style="margin-left:15px" class="feedback-message" *ngIf="feedbackMessage !== ''">{{ feedbackMessage }}</div>
</div>



<div id="akwa-rom-start"  *ngIf="!hideAkwaStartScreen">
    <div style="position: absolute; right:20px; top:20px; width: 250px;">
        <svg viewBox="0 0 411.69 112">
            <path
                class="ggz-logo_svg__title-segment-1"
                d="M67.91 52.56a20.32 20.32 0 01-15.81-6.73Q46 39.1 46 25.49q0-12 6.44-18.72A20.52 20.52 0 0167.84 0a18.92 18.92 0 0119.44 17.14l-9.72 1.58Q75.76 9 67.91 9a10.46 10.46 0 00-8.43 4.32Q56 17.64 56 25.49q0 9.21 3.35 13.64a10.24 10.24 0 008.53 4.43 10 10 0 007.38-2.66c1.8-1.78 2.7-4.27 2.7-7.49h-9.33v-8.28h18.65v6.7q0 9.57-5.4 15.15a18.58 18.58 0 01-13.97 5.58zm-46.02 0a20.32 20.32 0 01-15.81-6.73Q0 39.1 0 25.49q0-12 6.44-18.72A20.52 20.52 0 0121.82 0a18.92 18.92 0 0119.44 17.14l-9.72 1.58Q29.74 9 21.89 9a10.46 10.46 0 00-8.43 4.32Q10 17.64 10 25.49q0 9.21 3.35 13.64a10.24 10.24 0 008.53 4.43 10 10 0 007.38-2.66c1.8-1.78 2.7-4.27 2.7-7.49h-9.35v-8.28h18.65v6.7q0 9.57-5.4 15.15a18.58 18.58 0 01-13.97 5.58zM93 51.48v-9.14l24.34-31.76v-.14H94.05V1.08h35.42v9.14L105 42v.14h24.48v9.36z"
                fill="#6ebce0"
            ></path>
            <path
                class="ggz-logo_svg__title-segment-2"
                d="M0 94.07l10.23-2.23q.93 5.91 3.06 8.53C14.7 102.13 17 103 20.23 103a12.7 12.7 0 006.56-1.47 4.79 4.79 0 002.44-4.36 5.3 5.3 0 00-2.34-4.64q-2.34-1.62-10.69-4.22-7.84-2.44-11.12-5.94a12.05 12.05 0 01-3.28-8.6 13.27 13.27 0 014.57-10.12q4.58-4.21 12.42-4.21a21.45 21.45 0 0112.28 3.46 15.21 15.21 0 016.45 10.29l-9.44 2.38q-2.23-7.12-9.29-7.13a9 9 0 00-5.58 1.44 4.61 4.61 0 00-1.83 3.82 3.73 3.73 0 002.09 3.42 85 85 0 0010.72 4.14q8.36 2.88 11.45 6.23t3.1 9a14.08 14.08 0 01-5 11.09q-5 4.4-13.47 4.39t-13.9-4.47Q1.09 103 0 94.07zm47.52 3.24V80.68h-5.9v-7.92h6.12V63.4h8.85v9.36h9.65v7.92h-9.5v15.77c0 2 .33 3.43 1 4.25s2 1.22 4.1 1.22H65v9h-4q-7.71 0-10.59-3.24t-2.89-10.37zm46.95 13.61v-3.67h-.14q-.15.21-.36.54a8.71 8.71 0 01-1.08 1.12 12.62 12.62 0 01-2 1.44 12 12 0 01-3 1.15 15.72 15.72 0 01-4 .5q-6.92 0-10.34-3.27a10.7 10.7 0 01-3.42-8q0-5 3-7.56t10-4.32q6.56-1.59 8.21-2.52a2.92 2.92 0 001.66-2.7 3.43 3.43 0 00-1.62-2.88 8.46 8.46 0 00-4.86-1.15c-2.55 0-4.37.57-5.47 1.69a11.56 11.56 0 00-2.6 4.58l-7.77-3.24A14.82 14.82 0 0176 74.74q4-3.06 10.36-3.06 7 0 11.45 3.67t4.47 11.38v24.19zM85 95.3c-2.4.57-4 1.26-4.72 2a3.85 3.85 0 00-1.12 2.7c0 2.59 1.88 3.89 5.62 3.89 2.83 0 5-.54 6.37-1.62a4.86 4.86 0 002.13-4V91.7h-.15a3.44 3.44 0 01-.61.9 9.58 9.58 0 01-2.19 1.08A44.39 44.39 0 0185 95.3zm25.68 15.62V72.76h9v3.67h.14a12.55 12.55 0 014.32-3.38 12.78 12.78 0 015.76-1.37q6.34 0 9.94 3.78t3.6 10.48v25h-9.36v-22.7c0-2.64-.51-4.62-1.51-5.94s-2.74-2-5.19-2a6.77 6.77 0 00-7.38 7.29v23.33zm65.74 0v-3.67h-.14c-.24.34-.59.77-1 1.3a14.51 14.51 0 01-9 3.45 14.81 14.81 0 01-12.06-5.47q-4.5-5.48-4.5-14.69t4.9-14.72a15 15 0 0111.52-5.44 12.16 12.16 0 015.43 1.19 9.18 9.18 0 013.28 2.34l.93 1.22h.15V58.36h9.36v52.56zm-.57-15.62v-7a8.26 8.26 0 00-2.2-5.83 7.79 7.79 0 00-6-2.37 7.55 7.55 0 00-6.37 3C159.76 85 159 88 159 91.84s.76 6.76 2.27 8.75a7.53 7.53 0 006.37 3 7.71 7.71 0 006-2.41 8.39 8.39 0 002.21-5.88zM216 110.92v-3.67h-.14q-.15.21-.36.54a7.45 7.45 0 01-1.08 1.12 12.52 12.52 0 01-1.94 1.44 12.09 12.09 0 01-3 1.15 15.66 15.66 0 01-4 .5q-6.92 0-10.33-3.27a10.7 10.7 0 01-3.42-8q0-5 2.95-7.56t10-4.32c4.37-1.06 7.1-1.9 8.21-2.52a2.93 2.93 0 001.65-2.67 3.43 3.43 0 00-1.54-2.91 8.46 8.46 0 00-4.86-1.15c-2.54 0-4.36.57-5.47 1.69a11.54 11.54 0 00-2.59 4.58l-7.78-3.24a14.82 14.82 0 015.33-7.89q4-3.06 10.37-3.06a17.48 17.48 0 0111.45 3.67q4.47 3.68 4.46 11.38v24.19zm-9.4-15.62c-2.4.57-4 1.26-4.71 2a3.81 3.81 0 00-1.12 2.7q0 3.89 5.62 3.89 4.25 0 6.37-1.62a4.87 4.87 0 002.12-4V91.7h-.14a3.7 3.7 0 01-.61.9 9.75 9.75 0 01-2.2 1.08 43.82 43.82 0 01-5.33 1.62zm48.4 15.62v-3.67h-.15l-.36.54a7.45 7.45 0 01-1.08 1.12 10.49 10.49 0 01-4.89 2.59 15.8 15.8 0 01-4 .5q-6.9 0-10.33-3.27a10.7 10.7 0 01-3.42-8c0-3.31 1-5.83 2.95-7.56s5.31-3.17 10-4.32q6.56-1.59 8.21-2.52a2.92 2.92 0 001.66-2.67 3.43 3.43 0 00-1.62-2.88 8.46 8.46 0 00-4.86-1.15c-2.55 0-4.37.57-5.48 1.69a11.67 11.67 0 00-2.63 4.55l-7.77-3.24a14.81 14.81 0 015.32-7.89q4-3.06 10.37-3.06a17.48 17.48 0 0111.45 3.67q4.47 3.68 4.47 11.38v24.19zm-9.45-15.62c-2.4.57-4 1.26-4.71 2a3.81 3.81 0 00-1.12 2.7q0 3.89 5.62 3.89c2.83 0 5-.54 6.37-1.62a4.86 4.86 0 002.13-4V91.7h-.15a3.44 3.44 0 01-.61.9 9.75 9.75 0 01-2.2 1.08 43.82 43.82 0 01-5.33 1.62zm25.65 15.62V72.76h8.85v4h.15a8.3 8.3 0 013.2-3.45 8.7 8.7 0 014.65-1.3 8.54 8.54 0 013.45.72l-1.44 9.07a8.77 8.77 0 00-2.95-.57q-6.56 0-6.55 8.71v21zm50.69 0v-3.67h-.15c-.24.34-.59.77-1 1.3a14.44 14.44 0 01-9 3.45 14.81 14.81 0 01-12.06-5.47q-4.5-5.48-4.5-14.69T300 77.12a15 15 0 0111.52-5.44 12.13 12.13 0 015.48 1.19 9.18 9.18 0 013.28 2.34l.94 1.22h.14V58.36h9.36v52.56zm-.58-15.62v-7a8.26 8.26 0 00-2.2-5.83 7.77 7.77 0 00-6-2.37 7.57 7.57 0 00-6.37 3c-1.51 2-2.27 4.89-2.27 8.78s.76 6.76 2.27 8.75a7.55 7.55 0 006.37 3 7.7 7.7 0 006-2.41 8.39 8.39 0 002.2-5.92zm43.21 2.45l6.55 5.76Q365.24 112 355.3 112a16.82 16.82 0 01-13-5.51q-5-5.51-5-14.65t5-14.65a16.36 16.36 0 0112.64-5.51 16.14 16.14 0 0112.57 5.51q4.92 5.5 4.93 14.65v2.81h-25.71a10.24 10.24 0 002.42 6.73 7.83 7.83 0 006 2.34 8.57 8.57 0 005.36-1.62 18.66 18.66 0 004.01-4.35zm-17.79-10.08h16.57a8.83 8.83 0 00-2.52-5.73 8.22 8.22 0 00-5.91-2 7.57 7.57 0 00-5.65 2.23 8.76 8.76 0 00-2.49 5.5zm32.2 23.25V72.76h9v3.67h.14a12.55 12.55 0 014.32-3.38 12.78 12.78 0 015.76-1.37q6.35 0 9.94 3.78t3.6 10.48v25h-9.36v-22.7q0-4-1.51-5.94t-5.19-2a6.77 6.77 0 00-7.34 7.27v23.33z"
                fill="#6ebce0 !important"
            ></path>
        </svg>
    </div>


    <h2>Evaluatie<br>ondersteuning</h2>



    <p>

        De Evaluatieondersteuning helpt bij het vaststellen van het behandeldoel en het maken van afspraken over evalueren. De cliënt en behandelaar vullen samen een aantal vragen in. Na het beantwoorden volgt een overzicht met het evaluatieplan en tips voor het evaluatiegesprek. Dit overzicht kun je downloaden en gemakkelijk aanpassen tijdens de behandeling. 
        <br><br>
        <i>Gebruik de online Evaluatieondersteuning op je desktop of laptop.</i>
    <br>
    <br>    
    <button (click)="onHideAkwaStartScreen()" *ngIf="!hideAkwaStartScreen" class="next-question-button next-question-button-arrow">Start</button>
    </p>

    <img src="/assets/images/samen_beslissen_karakters-new.png" style="position: absolute; right:5%; top: 40%;  width: 30%;">
    
    <br class="clear-both">
</div>

<div id="loadingContent" *ngIf="loading">
    <div class="spinner">
        <div class="dot1"></div>
        <div class="dot2"></div>
    </div>
</div>

<div *ngIf="hideAkwaStartScreen">
    <ng-container *ngIf="!loading">    
        <div class="layout">

            <div class="menuBar">
                <alii-web-protocol-menubar
                    *ngIf="protocol"
                    (eventBus)="handleEventBus($event)"
                    [isEditAble]="isEditAble"
                    [protocol]="protocol"
                    [views]="views"
                    style="width: 100%"
                    [version]="version"
                    >
                </alii-web-protocol-menubar>
            </div>


            <!--    <div class="layout__page">-->
            <alii-web-protocol-sidebar
                *ngIf="protocol"
                (eventBus)="handleEventBus($event)"
                [isEditAble]="isEditAble"
                [protocol]="protocol"
                [versionId]="versionId"
                [version]="version"
                [currentVersion]="currentVersion"
                [draftVersion]="draftVersion"
                [deprecatedVersions]="deprecatedVersions"
                [storedDraftVersions]="storedDraftVersions"
                [scrollParagraphId]="scrollParagraphId"
                [pane]="pane"
                [ngClass]="{ waiting: loading }"
            >
            </alii-web-protocol-sidebar>

            <main id="content" class="layout__content margin-Top" *ngIf="pane === 'content'" [ngClass]="{ waiting: loading }">
                <div class="page">
                    <div class="loading-model-msg" *ngIf="loadingModel && showMessageIsLoading">Model is being
                        calculated
                    </div>

                    <div #scroll class="page__content py-4" id="protocol-detail">
                        <div class="row">
                            <img src="/assets/images/akwa-rom-top.png" style="width:90%; margin-left:0; margin-top:0;">
                        </div>

                        <alii-web-protocol-info
                            *ngIf="['Preview', 'Draft'].includes(version) && currentVersion !== 'flowchart'"
                            [protocol]="protocol"
                            [version]="version"
                            (eventBus)="handleEventBus($event)"
                        >
                        </alii-web-protocol-info>

                        <ng-container *ngIf="!loading">
                            <div *ngIf="protocol.banner && showBanner">
                                <ngb-alert class="banner" (close)="closeBanner()">{{ protocol.banner }}</ngb-alert>
                            </div>
                            <div id="protocolContent" class="mainContentArea">
                                <div *ngIf="currentView == 'flowchart'" id="flowChart" class="container-fluid">
                                    <flowchart-detail
                                        *ngIf="views.includes('flowchart')"
                                        [scheme]="protocol.flowchart?.scheme | asHtml"
                                        [flowchart]="protocol.flowchart"
                                        (eventBus)="handleEventBus($event)"
                                    >
                                    </flowchart-detail>
                                </div>

                                <div *ngIf="currentView == 'interactive' && protocol.flowchart.cards" class="container-fluid">
                                    <dialogue-detail
                                        [cards]="protocol.flowchart.cards"
                                        [paragraphs]="protocol.paragraphs"
                                        (eventBus)="handleEventBus($event)"
                                    >
                                    </dialogue-detail>
                                </div>

                                <ng-container *ngIf="currentView == 'text' || currentView == 'populations'">
                                    <alii-web-paragraph-detail
                                        *ngFor="let paragraph of protocol.paragraphs; trackBy: trackByFn; index as i"
                                        (eventBus)="handleEventBus($event)"
                                        [protocolId]="protocol.id"
                                        [parentId]="null"
                                        [index]="i"
                                        [populationId]="populationId"
                                        [paragraph]="paragraph"
                                        [isEditAble]="isEditAble"
                                        [paragraphSelectedId]="paragraphSelectedId"
                                        [modelFindings]="modelFindings"
                                        [modelOutcomes]="modelOutcomes"
                                        [modelTagList]="modelTagList"
                                        [modelMessages]="modelMessages"
                                        [viewByPopulation]="currentView == 'populations'"
                                        [gradeAssessment]="gradeAssessment"
                                        [columnDefs]="paragraph.columnDefs"
                                        [rowData]="paragraph.rowData"
                                        [populations]="populations"
                                        [sidebarCollapsed]="sidebarCollapsed"
                                        [hasNumberedIndex]="protocol.hasNumberedIndex"
                                        [version]="version"
                                        [currentQuestionTitle]="currentQuestionTitle"
                                    >
                                    </alii-web-paragraph-detail>


                                    <alii-web-protocol-literature
                                        *ngIf="protocol.search_term"
                                        [protocol]="protocol"
                                        (eventBus)="handleEventBus($event)"
                                    >
                                    </alii-web-protocol-literature>

                                    <alii-web-protocol-info
                                        *ngIf="!['Preview', 'Draft'].includes(version)"
                                        [protocol]="protocol"
                                        [version]="version"
                                        (eventBus)="handleEventBus($event)"
                                    ></alii-web-protocol-info>

                                    <alii-web-protocol-files
                                        *ngIf="protocol.files && protocol.files.length > 0"
                                        [files]="protocol.files"
                                    >
                                    </alii-web-protocol-files>
                                </ng-container>
                            </div>
                        </ng-container>


                    </div>
                </div>

                <div class="page__corner -top -right" style="z-index: 400" id="savePatientButton" *ngIf="!!populationId">
                    <div class="button-group">
                        <a
                            class="button"
                            (click)="handleOpenSavePatientLinkModal()"
                            [ngClass]="'-primary'"
                        >
                            <span class="button__icon"><span class="icon-alii-text"></span></span> Opslaan
                        </a>
                    </div>
                </div>
            </main>


            <main id="content-settings" class="layout__content" *ngIf="pane === 'settings'">
                <alii-web-protocol-settings [protocol]="protocol"
                                            (eventBus)="handleEventBus($event)"></alii-web-protocol-settings>
            </main>
        </div>
        <!--</div>-->
    </ng-container>
</div>
